import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IBandhaiData,
  ISettlementInitialState,
} from "./bandhaisettlementformModal";
import {
  getBandhaiSettlementDetail,
  updateBandhaiSettlementDetail,
} from "./services/settlementform.services";

const initialState: ISettlementInitialState = {
  loading: false,
  error: "",
  karigar_id: null,
  BandhaiSettlementDetail: null,
  // BandhaiSettlementDetail: {
  //   bandhaiissueorders: [],
  //   bandhaiapprovalitems: [],
  //   bandhaigoldissue: [],
  //   bansdhaireceiptorders: [],
  //   bansdaireceiptapprovalItems: [],
  // },
};

const settlementformSlice = createSlice({
  name: "settlementform",
  initialState,
  reducers: {
    setBandhaiSettlementDetail: (state, action) => {
      state.BandhaiSettlementDetail = action.payload;
    },
    clearBandhaiSettlementDetail: (state) => {
      state.BandhaiSettlementDetail = initialState.BandhaiSettlementDetail;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBandhaiSettlementDetail.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getBandhaiSettlementDetail.fulfilled,
      (state, action: PayloadAction<IBandhaiData>) => {
        state.loading = false;
        state.BandhaiSettlementDetail = action.payload;
      },
    );
    builder.addCase(getBandhaiSettlementDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BandhaiSettlementDetail = initialState.BandhaiSettlementDetail;
    });
    builder.addCase(updateBandhaiSettlementDetail.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateBandhaiSettlementDetail.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateBandhaiSettlementDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { setBandhaiSettlementDetail, clearBandhaiSettlementDetail } =
  settlementformSlice.actions;
export default settlementformSlice.reducer;
